export const ELocalStorageKeys = Object.freeze({
  ACCESS_TOKEN: "@voltexploit/auth/access-token",
  REFRESH_TOKEN: "@voltexploit/auth/refresh-token",
} as const);
